import React, { useEffect, useState, useMemo } from "react";
import { Grid, Typography, Select, MenuItem, Paper, Box, IconButton } from "@mui/material";
import { Table } from "react-bootstrap";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { Label } from "@fluentui/react";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const DelegatedHistorySection = ({initiativeID}) => {
  const [historyData, setHistoryData] = useState([]);
  const [selectedField, setSelectedField] = useState(""); // State for Modified Field
  const [selectedBy, setSelectedBy] = useState(""); // State for Modified By
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false); // Track if there are more pages
  const [totalRecords, setTotalRecords] = useState(0); // Track total number of records
  // Memoize userID to prevent unnecessary re-renders
  // const userID = useMemo(() => {
  //   const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  //   return user.employeeId;
  // }, []);

  // Pagination code
  useEffect(() => {
    // Only fetch if userID exists
    // if (!userID) return;
    if (!initiativeID) return;
    const fetchHistoryData = async () => {
      setLoading(true);
      const token = sessionStorage.getItem("access_token");
      // const url = `/api/InitiativeDelegateApproval/GetInitiativeDelegatHistory?UserID=${userID}&PageNumber=${page}`;
      const url = `/api/InitiativeDelegateApproval/GetInitiativeDelegatHistory?InitiativeID=${initiativeID}&PageNumber=${page}`;
      try {
        const response = await AxiosInstance1.get(url);

        if (response.status !== 200) {
          throw new Error("Failed to fetch data");
        }

        const data = response?.data?.data;
        const history = data?.InitiativeDelegateHistoryEntitiy || [];
        console.log("Fetched History:", history);
        
        setHistoryData(history);   // for display
        setTableData(history);     // for pagination length check
        
        // Check if there are more pages available
        // Method 1: If API returns total count, calculate if there are more pages
        if (data?.totalRecords) {
          setTotalRecords(data.totalRecords);
          const recordsPerPage = 5;
          const currentRecordEnd = page * recordsPerPage;
          setHasNextPage(currentRecordEnd < data.totalRecords);
        }
        // Method 2: If API returns hasNextPage flag directly
        else if (data?.hasNextPage !== undefined) {
          setHasNextPage(data.hasNextPage);
        }
        // Method 3: Fallback - fetch next page to check if it has data
        else {
          // Try to fetch the next page to see if it has data
          // const nextPageUrl = `/api/InitiativeDelegateApproval/GetInitiativeDelegatHistory?UserID=${userID}&PageNumber=${page + 1}`;
          const nextPageUrl = `/api/InitiativeDelegateApproval/GetInitiativeDelegatHistory?InitiativeID=${initiativeID}&PageNumber=${page + 1}`;
          AxiosInstance1.get(nextPageUrl)
            .then(nextResponse => {
              const nextData = nextResponse?.data?.data;
              const nextHistory = nextData?.InitiativeDelegateHistoryEntitiy || [];
              setHasNextPage(nextHistory.length > 0);
            })
            .catch(() => {
              setHasNextPage(false);
            });
        }

      } catch (error) {
        console.error("Error fetching history data:", error);
        setHasNextPage(false); // No next page on error
      } finally {
        setLoading(false);
      }
    };

    fetchHistoryData();
  }, [page, initiativeID]);
  // [page, userID]); // Include userID in dependencies

  const handlePreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        mt={2}
        mb={2}
        sx={{
          backgroundColor: "#f0f0f0",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
        }}
      >
      </Grid>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Modified Field</th>
            <th>Modified Date</th>
            <th>Old Value</th>
            <th>New Value</th>
            <th>Modified By</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          ) : historyData.length > 0 ? (
            historyData.map((row, index) => (
              <tr key={index}>
                <td>{row.modifiedField}</td>
                <td>
                  {new Date(row.modifiedDate).toLocaleDateString("en-GB").replace(/\//g, "-")}
                </td>
                <td>{row.oldValue || "N/A"}</td>
                <td>{row.newValue || "N/A"}</td>
                <td>{row.modifiedBy || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                There are no items to show in this view.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <IconButton onClick={handlePreviousPage} disabled={page === 1 || loading}>
          <ArrowBackIcon />
        </IconButton>
        <Typography sx={{ margin: "0 10px", alignSelf: "center" }}>Page {page}</Typography>
        <IconButton
          onClick={handleNextPage}
          disabled={!hasNextPage || loading} // Disable if no next page or loading
        >
          <ArrowForwardIcon />
        </IconButton>
      </Box>   
    </div>
  );
};

export default DelegatedHistorySection;